var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMosaic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.324219 10.5996C0.324219 5.07676 4.80137 0.599609 10.3242 0.599609H38.3242C43.8471 0.599609 48.3242 5.07676 48.3242 10.5996V38.5996C48.3242 44.1225 43.8471 48.5996 38.3242 48.5996H10.3242C4.80137 48.5996 0.324219 44.1225 0.324219 38.5996V10.5996Z",
    fill: "url(#paint0_linear_4168_5829)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3242 19.5996V16.5996C31.3242 16.3344 31.2189 16.08 31.0313 15.8925C30.8438 15.705 30.5894 15.5996 30.3242 15.5996H17.3242C16.7938 15.5996 16.2851 15.8103 15.91 16.1854C15.5349 16.5605 15.3242 17.0692 15.3242 17.5996C15.3242 18.13 15.5349 18.6388 15.91 19.0138C16.2851 19.3889 16.7938 19.5996 17.3242 19.5996H32.3242C32.5894 19.5996 32.8438 19.705 33.0313 19.8925C33.2189 20.08 33.3242 20.3344 33.3242 20.5996V24.5996M33.3242 24.5996H30.3242C29.7938 24.5996 29.2851 24.8103 28.91 25.1854C28.5349 25.5605 28.3242 26.0692 28.3242 26.5996C28.3242 27.13 28.5349 27.6387 28.91 28.0138C29.2851 28.3889 29.7938 28.5996 30.3242 28.5996H33.3242C33.5894 28.5996 33.8438 28.4943 34.0313 28.3067C34.2189 28.1192 34.3242 27.8648 34.3242 27.5996V25.5996C34.3242 25.3344 34.2189 25.08 34.0313 24.8925C33.8438 24.705 33.5894 24.5996 33.3242 24.5996Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3242 17.5996V31.5996C15.3242 32.13 15.5349 32.6387 15.91 33.0138C16.2851 33.3889 16.7938 33.5996 17.3242 33.5996H32.3242C32.5894 33.5996 32.8438 33.4943 33.0313 33.3067C33.2189 33.1192 33.3242 32.8648 33.3242 32.5996V28.5996",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4168_5829",
    x1: 24.3242,
    y1: 0.599609,
    x2: 24.3242,
    y2: 48.5996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#155DFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60A5FA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMosaic);
export default __webpack_public_path__ + "static/media/mosaic.0360a3507dedbebf064de1a33f4c3655.svg";
export { ForwardRef as ReactComponent };